let inject = ['$scope', '$uibModalInstance', '$timeout', 'SessionService', 'modalOptions'];

class CreateTemplateModalController {
  constructor ($scope,$uibModalInstance, $timeout, SessionService, modalOptions) {
    this.$scope = $scope;
    this.$timeout = $timeout;
    this.SessionService = SessionService;
    this.$uibModalInstance = $uibModalInstance;
    this.modalOptions = modalOptions;
  }

  cancel() {
    this.$uibModalInstance.dismiss('cancel');
  }

  ok() {
    this.$uibModalInstance.close();
  }
}

CreateTemplateModalController.$inject = inject;

export default CreateTemplateModalController;



/** WEBPACK FOOTER **
 ** C:/xampp/htdocs/payomaro-pay-zone/www/components/cart/modal-cart-seller/modal-cart-seller.controller.js
 **/